export default __webpack_public_path__ + "static/media/homeLogo.a6805020.png";